import { render, staticRenderFns } from "./menu-header.component.vue?vue&type=template&id=6b40781a&scoped=true&"
import script from "./menu-header.component.vue?vue&type=script&lang=ts&"
export * from "./menu-header.component.vue?vue&type=script&lang=ts&"
import style0 from "./menu-header.component.vue?vue&type=style&index=0&id=6b40781a&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b40781a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VDivider,VSpacer})
